import { render, staticRenderFns } from "./ForRelease.vue?vue&type=template&id=7877c59f&scoped=true"
import script from "./ForRelease.vue?vue&type=script&lang=js"
export * from "./ForRelease.vue?vue&type=script&lang=js"
import style0 from "./ForRelease.vue?vue&type=style&index=0&id=7877c59f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7877c59f",
  null
  
)

export default component.exports